import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme, _params) => ({
    image: {
        width: '100%',
        position: 'relative',
        '& img': {
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
        },
    },
    fullWidthImage: {
        [theme.breakpoints.up('sm')]: {
            paddingTop: 0,
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
        },
    },
    squareImage: {
        paddingTop: '100%',
        [theme.breakpoints.up('sm')]: {
            paddingTop: '50%',
        },
    },
    imageSpacer: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            width: '50%',
        },
    },
}));
export default useStyles;
